/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Load_FileInputs */

const en_btn_load_file = /** @type {(inputs: Btn_Load_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open File`)
};

const ko_btn_load_file = /** @type {(inputs: Btn_Load_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일 열기`)
};

const ja_btn_load_file = /** @type {(inputs: Btn_Load_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルを開く`)
};

/**
* | output |
* | --- |
* | "Open File" |
*
* @param {Btn_Load_FileInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const btn_load_file = /** @type {((inputs?: Btn_Load_FileInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Load_FileInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_load_file(inputs)
	if (locale === "ko") return ko_btn_load_file(inputs)
	return ja_btn_load_file(inputs)
});